import React, { Component } from "react";
import PropTypes from "prop-types";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import * as AnnotationsModule from "highcharts/modules/annotations";
import { isMobileDevice, convertToCurrencyFormat } from "../../helpers/Utils";
import StyleConstants from "../../shared/constants/styleConstants/styles.json";
import moment from "moment";

const IS_MOBILE = isMobileDevice();

AnnotationsModule(Highcharts);

class StackedBarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderGraph() {
    const { rawGraphData, xAxisLabels, campus } = this.props;
    let classrooms = [];
    let seriesData = [
      { name: "Payments", data: [], color: "grey" },
      { name: "Dues", data: [], color: StyleConstants.color.darkBlue },
    ];
    if (this.props.multiCampuses) {
      rawGraphData.map((data) => {
        if (xAxisLabels.map((label) => label.value).includes(data.campus_id)) {
          seriesData[0].data.push(data.received_fee);
          seriesData[1].data.push(
            data.total_receivable_fee - data.received_fee
          );
        }
      });
    } else {
      classrooms = rawGraphData.filter(
        (data) => data.campus_id === campus[0].value
      );
      classrooms.map((classroom) => {
        seriesData[0].data.push(parseInt(classroom.total_payment));
        seriesData[1].data.push(
          parseInt(classroom.total_fees) - parseInt(classroom.total_payment)
        );
      });
    }
    const options = {
      chart: {
        type: "column",
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        title: {
          text: this.props.multiCampuses ? "Campuses" : "Classrooms",
          margin: 10,
        },
        categories: this.props.multiCampuses
          ? xAxisLabels.map((label) => label.label)
          : classrooms.map((classroom) => classroom.name),
      },
      yAxis: {
        min: 0,
        title: {
          text: "Total Recievables",
          margin: 20,
        },
        labels: {
          formatter() {
            return convertToCurrencyFormat(this.value, "");
          },
        },
      },

      tooltip: {
        formatter() {
          return `<div><b>${this.x}</b><br/>
                       <b>${this.series.name}</b>: ${convertToCurrencyFormat(
            this.y
          )} <br/>
          <b>Total:</b> ${convertToCurrencyFormat(this.total)}
       </div>`;
        },
      },
      plotOptions: {
        column: {
          stacking: "normal",
        },
        series: {
          pointWidth: 60,
        },
      },
      series: seriesData,
    };
    return (
      <div
        style={{
          margin: IS_MOBILE ? "0 10px 0 0" : "20px 30px 20px 20px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          style={{ zIndex: 0 }}
        />
      </div>
    );
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: 0,
          width: "100%",
          backgroundColor: "white",
          marginTop: 5,
          marginBottom: 30,
          justifyContent: "center",
          height: "max-content",
          borderRadius: 10,
          boxShadow: "1px 2px 6px #8b9daf26",
        }}
      >
        {this.renderGraph()}
      </div>
    );
  }
}

export default StackedBarChart;
